import _ from 'lodash';
import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { getCompany } from './company.selectors';

export const getCompanyPropertiesState = createSelector(
  getCompany,
  ({ companyProperties }) => companyProperties,
);

const selectCompanyPropertiesNew = memoizeOne(companyId =>
  createSelector(getCompanyPropertiesState, companyProperties => companyProperties[companyId]),
);

export const selectCompanyPropertiesNewMap = memoizeOne(companyId =>
  createSelector(selectCompanyPropertiesNew(companyId), companyProperties =>
    _.keyBy(companyProperties || [], 'propertyName'),
  ),
);

export const selectHasLoadedCompanyProperties = memoizeOne(companyId =>
  createSelector(
    selectCompanyPropertiesNew(companyId),
    companyProperties => !_.isNil(companyProperties),
  ),
);
